// import IconButton from "../../shared/IconButton/IconButton"
import React, { useState, useEffect } from 'react'

import Texts from 'react-sdk/Texts';
import DownloadableFiles from '../../../../js/DownloadableFiles';
import Button from '../../../shared/Button/Button';
import AppState from '../../../../js/AppState';
import InlineSvg from '../../../shared/InlineSvg/InlineSvg'

import './Download.css'

import button_play from '../../../../images/icones/chevron-right.png'

const DownloadElement = ({element}) => {


  const downloadFile = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = element.fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  function blockClick(e) {
    e.stopPropagation()

  }

  function handleDownload(e) {
    if(element.filePath == null)
      return;

    blockClick(e)

    let path = null;

    if(element.filePath.includes("http"))
      path = element.filePath;
    else
      path = AppState.files_root + window.CONFIG.download_root + element.filePath;

    downloadFile(path)
  }

  return (
    <div className={"element"} onClick={(e) => blockClick(e)}>
    { 
      element.title
    }
    <Button className="download-button" onClick={(e) => handleDownload(e)} children={<svg id="Layer_1" height="512" viewBox="0 0 48 48" width="512" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="m24 0a24 24 0 1 0 24 24 24 24 0 0 0 -24-24zm7.873 39.46h-15.746a2 2 0 1 1 0-4h15.746a2 2 0 0 1 0 4zm1.414-15.044-7.879 7.884a2 2 0 0 1 -2.828 0l-7.867-7.866a2 2 0 0 1 2.828-2.834l4.459 4.459v-17.694a2 2 0 0 1 4 0v17.682l4.459-4.459a2 2 0 0 1 2.828 2.828z"/></svg>}/>
    </div>
  );
};

const Download = ({content, onClick}) => {

  let downloadables = []
  content.split(";").forEach(element => {
    if(DownloadableFiles.get(element))
      downloadables.push(DownloadableFiles.get(element))
    else
      console.warn("Downloadable element \"" + element + "\" doesn't exist in downloadable files")
  }); 

  function handleClick(e) {
    e.stopPropagation()
    if(onClick) onClick()
  }

  return (
    <div className={"Download"}>
      <div className={"title"}> { Texts.get("download-title") } </div>
      <div className={"content"} onClick={(e) => handleClick(e)}>
      {
        downloadables.map((elem, i) => 
          <DownloadElement key={"key"+i} element={elem} />
        )
      }
      </div>
    </div>
  );
};
export default Download
